<template>
  <div class="container"> 
   
    <div class="box">
        <input type="text" class="search_box" v-model="name" @change="initData"  placeholder="请输入搜索内容">
        <img class="search_icon" @click="initData" :src='searchImg' alt="">
        <!-- <div class="btn" @click="sure">返回</div> -->
    </div>
    <div class="content">
      <div class="item" v-for="(item,index) in schoolList" :key="index" @click="chose(item)">{{item.school_name}}</div>
    </div>
 
  </div>
</template>
<style scoped>
input::-webkit-input-placeholder { 
/* WebKit browsers */ 
color: rgb(132,132,132); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
color: rgb(132,132,132); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
color: rgb(132,132,132); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
color: rgb(132,132,132); 
}
.container{
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.btn{
  width: 60px;
  height: 30px;
  border-radius: 18px;
  line-height: 30px;
  background-color: #B3212D;
  color: #fff;
  position: absolute;
  top: 13px;
  text-align: center;
  font-size: 14px;
  right: 25px;
}
.box{
  position: relative;
  height: 56px;
  background-color:rgb(236,236,236);
}
.search_box{
  -web-kit-appearance:none;
  -moz-appearance: none;
  width: calc(100% - 60px);
  height: 32px;
  line-height: 32px;
  top: 12px;
  left: 30px;
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 16px;
  border-width: 0px;
  border-color: #dddddd;
  flex-direction: row;
  align-items: center;
  outline: 0;
  font-size: 14px;
  padding-left: 40px;
  box-sizing: border-box;
  color:rgb(34,34,34)
}
.search_icon{
  width: 16px;
  height: 16px;
  position: absolute;
  top: 20px;
  left: 45px;
}
.content{
  height: calc(100vh - 56px);
  overflow: scroll;
}
.item{
  height: 45px;
  line-height: 45px;
  padding-left: 30px;
  box-sizing: border-box;
  color: rgb(34,34,34);
  font-size: 14px;
  border-bottom:1px solid #e7e7e7;
}

</style>

<script>
import {getSchool} from '../apollo/apollo'
export default {
   components: {
    
  },
  data() {
    return {
      searchImg:'./static/imgs/search.png',
      getSchool:getSchool,
      schoolList:[],
      name:""
    }
  },
  computed:{
    
  },
  created() {
    
  },
  created(){
    
    // this.initData()
  },
  methods: {
    chose(item){
      this.name=item.school_name
      this.$store.state.news.school_name=this.name
      this.jump('./mylabel')
    },
    // sure(){
    //   this.$store.state.news.school_name=this.name
    //   this.jump('./mylabel')
    // },
    initData() {
      this.name=this.name+""
      getSchool({school_name:this.name}).then(res=>{
        this.schoolList=res.data.getSchool
      })
        
    },

    


  }, 

  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/schoolSearch.vue